import { ThemeProvider, createTheme } from "@mui/material";
import { red } from "@mui/material/colors";
import "./App.css";
import AppRouter from "./router";
import React from "react";
import Context from "./context";

function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#000", // This is an orange looking color
      },
      secondary: {
        main: "#cecece", //Another orange-ish color
      },
    },
  });
  return (
    <React.StrictMode>
      <Context>
        <ThemeProvider theme={theme}>
          <AppRouter />
        </ThemeProvider>
      </Context>
    </React.StrictMode>
  );
}

export default App;
